import { useRecoilValue } from 'recoil'
import { appInterface } from '@store/isApp'

const useOutlink = () => {
	const nativeEvent = useRecoilValue(appInterface)
	const onLink = (link: string) =>
		nativeEvent({
			key: 'outlink',
			value: {
				pageUrl: link,
			},
		})

	return {
		onLink,
	}
}
export default useOutlink
